import { getLastIndexOf } from '@/modules/globalModule/components/helperMethods';
import { Message } from '@/modules/nodesCanvasModule/components/storeClasses/message';
import {
  CustomSrvText,
  Service
} from '@/modules/nodesCanvasModule/components/storeClasses/service';

export const processCustomMsgText = (
  msg: Message,
  editorText: string
): string => {
  let customText = '';
  if (editorText.includes('# add custom message fields below\n')) {
    customText = editorText
      .slice(getLastIndexOf(editorText, '# add custom message fields below\n'))
      .trimEnd();
  }
  return customText;
};

export const processCustomSrvText = (
  srv: Service,
  editorText: string
): CustomSrvText => {
  let customText = srv.customText;
  if (
    editorText.includes('# add custom requests below\n') &&
    editorText.includes('---')
  ) {
    customText.requestText = editorText
      .slice(
        getLastIndexOf(editorText, '# add custom requests below\n'),
        editorText.indexOf('---')
      )
      .trimEnd();
  }

  if (editorText.includes('# add custom responses below\n')) {
    customText.responseText = editorText
      .slice(getLastIndexOf(editorText, '# add custom responses below\n'))
      .trimEnd();
  }

  return customText;
};
